import { trackPageLoad } from './aep_analytics_util.js';
import { loadFonts, init as initDynamicKit } from './DynamicKit.js';
import { init as initIms } from './imslib.js';
import { enableConsentCheck } from './adobe_privacy.js';
import { registerEventHandlers as registerPageLoadDialogEventHandlers } from '../components/mixins/PageLoadDialog.ts';
import SitewideHeaderController from '../controllers/sitewide_header.js';
import { initSUSILight } from './susi_light_util.js';
import UrlService from './url_service.js';

/**
 * Global setup that is applicable everywhere including, backend and legacy-backend pages.
 */
export function setupGlobals() {
  UrlService.removeSearchParam('logged_out');

  initDynamicKit();
  loadFonts();
  initIms();
}

/**
 * Global setup that is only applicable to the customer-facing side of the site.
 */
export function setupClientGlobals() {
  if (window.location.pathname.includes('backend')) {
    return;
  }

  enableConsentCheck();
  const sitewideHeaderController = new SitewideHeaderController();
  sitewideHeaderController.init();
  initSUSILight();

  registerPageLoadDialogEventHandlers();

  trackPageLoad();
}
